module.exports = __webpack_public_path__ + "static/media/omzchat-gray.e9a6acf7.svg";